<script setup lang="ts">
import ButtonText, {
  ButtonTextTheme
} from '@/shared/components/UI/Buttons/ButtonText.vue';
import { useTranslations } from '@/shared/composables/useTranslations';

defineProps<{
  error: string;
  theme?: ButtonTextTheme;
  disabled?: boolean;
  overflowCharacter?: boolean;
  retry?: () => void;
}>();

defineEmits(['close']);

const { t } = useTranslations();
</script>

<template>
  <div
    class="mx-auto mt-12 flex min-h-96 w-full max-w-2xl flex-col items-center justify-center gap-8 pt-6 md:w-8/12"
    :class="{ 'relative md:w-full': overflowCharacter }"
  >
    <h1 class="text-3xl font-bold">{{ t('global.errors.oh-no') }}</h1>

    <div class="mx-4 text-center text-lg text-gray-500">
      {{ error }}
    </div>

    <ButtonText
      v-if="retry"
      :disabled="disabled"
      class="mt-4 text-white"
      :class="{ 'z-1': overflowCharacter }"
      :theme="theme"
      size="lg"
      @click="retry"
    >
      {{ t('global.errors.retry') }}
    </ButtonText>
    <ButtonText
      v-else
      class="mt-4 text-white"
      :class="{ 'z-1': overflowCharacter }"
      :theme="theme"
      size="lg"
      @click="$emit('close')"
    >
      {{ t('global.ok') }}
    </ButtonText>

    <div
      class="flex size-80 w-full justify-end overflow-hidden"
      :class="{ 'h-16 w-full': overflowCharacter }"
    >
      <img
        src="@/images/yarnies/yarn-character-oops.png"
        alt=""
        class="w-80"
        :class="{ 'absolute -bottom-40 -right-16 w-72': overflowCharacter }"
      />
    </div>
  </div>
</template>
